import React from "react";
import PaymentMethodsRadioButtons from "components/common/PaymentMethodsRadioButtons";
import PlaidLink from "react-plaid-link";
import FinicityConnect from "components/common/FinicityConnect";

// TODO: Get value from config. This is a limit set by Synapse.
const synapseACHNodeCountLimit = 15;

const PaymentMethods = ({
  user,
  SettingsButton,
  addPaymentMethod,
  removePaymentMethod,
  relinkPaymentMethod,
  updateFinicityPaymentMethods,
  handlePaymentMethodChanged,
  inProgress,
  setErrorMessage,
  resetSuccess,
  setError,
  isMobile,
  showAddMore = true,
  forceShowSettingsButton = false,
  disabledDefaultPaymentMethodIds = [],
}) => {
  const handlePlaidOnLoad = (error, metadata) => {
    console.log("plaid onLoad - error:", error, "metadata: ", metadata);
  };

  const handlePlaidOnExit = (error, metadata) => {
    console.log("plaid onExit - error:", error, "metadata:", metadata);
  };

  const handlePlaidOnEvent = (eventType, metadata) => {
    console.log("plaid onEvent - type:", eventType, "metadata: ", metadata);

    if (eventType === "OPEN") {
      setErrorMessage("");
    }
    if (eventType === "ERROR" && metadata.error_code) {
      if (metadata.error_code === "NO_AUTH_ACCOUNTS") {
        setErrorMessage("No valid checking or savings account(s) found");
      } else {
        setErrorMessage(
          "Something went wrong. Please try again or contact support.",
        );
      }
      console.log(
        "Plaid link reported an error: Error code",
        metadata.error_code,
        "-",
        metadata.error_message,
      );
    }
    if (eventType === "HANDOFF") {
      console.log("Handoff");
    }
  };

  const handlePlaidOnSuccess = (token, metadata) => {
    console.log("plaid onSuccess - metadata:", metadata);

    // if (
    //   user.payment_methods.length + metadata.accounts.length >
    //   synapseACHNodeCountLimit
    // ) {
    //   setErrorMessage(
    //     `Too many accounts selected. You may add up to ${synapseACHNodeCountLimit} accounts.`
    //   );
    //   return;
    // }

    const filteredAccounts = metadata.accounts
      .filter((a) => ["checking", "savings"].includes(a.subtype))
      .map((a) => {
        const { id, mask, name, subtype, type } = a;
        return { id, mask, name, subtype, type };
      });

    const sentData = {
      public_token: token,
      accounts: filteredAccounts,
      institution: metadata.institution,
      link_session_id: metadata.link_session_id,
    };

    addPaymentMethod(sentData);
  };

  // const accountLimitReached =
  //   user.payment_methods.length >= synapseACHNodeCountLimit;
  const defaultId = user.default_payment_method_id;

  const aggregator = user.aggregator_type || "plaid";

  return (
    <div className={isMobile ? "py-8" : "flex-1"}>
      <p className="font-bold">Default Payment Method</p>
      <PaymentMethodsRadioButtons
        paymentMethods={user.payment_methods.map((m) => {
          return {
            ...m,
            selected: m.id === defaultId,
            disabled:
              m.unlinked || disabledDefaultPaymentMethodIds.includes(m.id),
            isAlreadySecondary: disabledDefaultPaymentMethodIds.includes(m.id),
          };
        })}
        didSelect={handlePaymentMethodChanged}
        handleRemove={removePaymentMethod}
        handleRelink={relinkPaymentMethod}
        className="my-4"
        disabled={inProgress}
        // allowRemoveForIds={
        //   defaultId && user.payment_methods.length > 1
        //     ? user.payment_methods.reduce((a, m) => {
        //         if (m.id !== defaultId) {
        //           a.push(m.id);
        //         }
        //         return a;
        //       }, [])
        //     : []
        // }
      />
      {!isMobile || forceShowSettingsButton ? <SettingsButton /> : <></>}
      {showAddMore ? (
        <div className="inline-block">
          {inProgress ? (
            <div
              className={`${
                !isMobile ? "ml-4 px-4" : ""
              } py-2 cursor-default text-gray-400`}
            >
              + add new account
            </div>
          ) : aggregator === "finicity" ? (
            <>
              <FinicityConnect
                allowShowMore
                showMoreAccounts={() => {
                  const plaidDivEl = document.getElementById(
                    "plaid-button-div",
                  );
                  const plaidButtonEl = plaidDivEl.getElementsByTagName(
                    "button",
                  );
                  plaidButtonEl[0].click();
                  updateFinicityPaymentMethods();
                }}
                onSuccess={(data) => {
                  console.log("onSuccess data:", data);
                  updateFinicityPaymentMethods();
                }}
                onCancel={(data) => {
                  console.log("onCancel data:", data);
                  updateFinicityPaymentMethods();
                }}
                onError={(data) => {
                  console.log("onError data:", data);
                  if (data?.code === 201) {
                    updateFinicityPaymentMethods();
                  }
                }}
                onLoaded={(data) => {
                  console.log("onLoaded data:", data);
                }}
                onRouteEvent={(data) => {
                  console.log("onRouteEvent data:", data);
                }}
                onUserEvent={(data) => {
                  console.log("onUserEvent data:", data);
                  if (data?.data?.action === "End" && data?.code === 201) {
                    updateFinicityPaymentMethods();
                  }
                }}
              />
              <div id="plaid-button-div" className="hidden">
                <PlaidLink
                  clientName="Tomo Credit"
                  className={`${
                    !isMobile ? "ml-4 px-4" : "underline"
                  } py-2 hoverColor`}
                  style={{ border: "none", background: "none" }}
                  env={process.env.REACT_APP_PLAID_ENV}
                  product={["auth", "assets"]}
                  publicKey="f9d5c9d432e4d2c64e5b0cf80f897f"
                  onLoad={handlePlaidOnLoad}
                  onEvent={handlePlaidOnEvent}
                  onSuccess={handlePlaidOnSuccess}
                  onExit={handlePlaidOnExit}
                  onClick={() => {
                    if (!isMobile) {
                      resetSuccess();
                      setError(false);
                    }
                  }}
                >
                  + add new account
                </PlaidLink>
              </div>
            </>
          ) : (
            <PlaidLink
              clientName="Tomo Credit"
              className={`${
                !isMobile ? "ml-4 px-4" : "underline"
              } py-2 hoverColor`}
              style={{ border: "none", background: "none" }}
              env={process.env.REACT_APP_PLAID_ENV}
              product={["auth", "assets"]} // While we only need auth for a payment method, we want to have a fully-functional access token on file
              publicKey="f9d5c9d432e4d2c64e5b0cf80f897f" // TODO: Get value from env
              onLoad={handlePlaidOnLoad}
              onEvent={handlePlaidOnEvent}
              onSuccess={handlePlaidOnSuccess}
              onExit={handlePlaidOnExit}
              webhook="https://enrjdsgppce0l3p.m.pipedream.net" // TODO: Get value from env
              onClick={() => {
                if (!isMobile) {
                  resetSuccess();
                  setError(false);
                }
              }}
            >
              + add new account
            </PlaidLink>
          )}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default PaymentMethods;
